/** Demo content for the "Underwriting" step. */
export const Underwriting = () => {
    return <p>Underwriting content goes here.</p>;
};
